import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { BADGE_TEXT_COLOR, INSIGHT_TYPE_CONFIG } from "./consts";
import type { InsightType } from "./types";

interface IInsightCardProps {
    type: InsightType;
    text: string;
    index: number;
}

export const InsightCard = ({ type, text, index }: IInsightCardProps) => {
    const config = INSIGHT_TYPE_CONFIG[type];

    return (
        <Flex
            flexDirection="column"
            alignItems="flex-start"
            gap="8px"
            background={colorsPalettes.carbon[0]}
            border={`1px solid ${colorsPalettes.carbon[50]}`}
            borderRadius="6px"
            padding="12px"
            flex="1"
            minWidth="0"
            data-automation={`overview-report-insight-card-${index}`}
        >
            <Flex
                inline
                alignItems="center"
                padding="4px 6px"
                borderRadius="8px"
                background={config.badgeColor}
            >
                <Text
                    fontVariant="tag"
                    color={BADGE_TEXT_COLOR}
                    textTransform="uppercase"
                >
                    {translate(config.translationKey)}
                </Text>
            </Flex>
            <Text fontVariant="body2" color={colorsPalettes.carbon[400]}>
                {text}
            </Text>
        </Flex>
    );
};
